import React from "react";

import { SignatureSuccessDesktop as StyledSignatureSuccessDesktop } from "./SignatureSuccessDesktop.styles.js";
import { formatCpf, formatCnpj } from '../../../utils/formatter';
import Icon from '../../../components/Icon';


import Loading from "../../../components/Loading";
import successPure from "../../../assets/images/success-pure.svg";

function SignatureSuccessDesktop({ document, documentTextMarkup, exportPdf, loading }) {
	if (!document || loading) {
		return <Loading />;
	}

	return (
		<StyledSignatureSuccessDesktop>
			<StyledSignatureSuccessDesktop.Term>
				<StyledSignatureSuccessDesktop.TermContainer>
					<StyledSignatureSuccessDesktop.TermTextContainer>
						<StyledSignatureSuccessDesktop.TermTitle>
							{document.title}
						</StyledSignatureSuccessDesktop.TermTitle>

						<StyledSignatureSuccessDesktop.TermText style={{ maxHeight: '388px', marginTop: '16px', overflowY: 'scroll' }}>
							<span dangerouslySetInnerHTML={documentTextMarkup()}></span>
						</StyledSignatureSuccessDesktop.TermText>
					</StyledSignatureSuccessDesktop.TermTextContainer>
					<StyledSignatureSuccessDesktop.TermFooter>
						<StyledSignatureSuccessDesktop.UserContainer>
							<StyledSignatureSuccessDesktop.ContainerSignature>
								<StyledSignatureSuccessDesktop.SignatureBox src={document.signature_url} />
							</StyledSignatureSuccessDesktop.ContainerSignature>
						</StyledSignatureSuccessDesktop.UserContainer>

						<StyledSignatureSuccessDesktop.UserContainer style={{ paddingBottom: '16px', textAlign: 'center' }}>
							<StyledSignatureSuccessDesktop.UserName>
								{document?.destinatary?.name}
							</StyledSignatureSuccessDesktop.UserName>
							<StyledSignatureSuccessDesktop.Cpf>
								{document?.destinatary?.cpf ? formatCpf(document?.destinatary?.cpf) : formatCnpj(document?.destinatary?.cnpj)}
							</StyledSignatureSuccessDesktop.Cpf>
						</StyledSignatureSuccessDesktop.UserContainer>
					</StyledSignatureSuccessDesktop.TermFooter>
				</StyledSignatureSuccessDesktop.TermContainer>
			</StyledSignatureSuccessDesktop.Term>

			<StyledSignatureSuccessDesktop.Signature>
				<StyledSignatureSuccessDesktop.SignatureContainer>
					<StyledSignatureSuccessDesktop.SignatureCenter>
						<StyledSignatureSuccessDesktop.ImageSuccess src={successPure} />
					</StyledSignatureSuccessDesktop.SignatureCenter>
					<StyledSignatureSuccessDesktop.SignatureCenter>
						<StyledSignatureSuccessDesktop.SignatureTitle>
							O documento foi assinado com sucesso
						</StyledSignatureSuccessDesktop.SignatureTitle>
					</StyledSignatureSuccessDesktop.SignatureCenter>
					<StyledSignatureSuccessDesktop.SignatureCenter>
						<StyledSignatureSuccessDesktop.SignatureText>
							Enviamos sua resposta para {document?.company?.name}.
						</StyledSignatureSuccessDesktop.SignatureText>
					</StyledSignatureSuccessDesktop.SignatureCenter>
					<StyledSignatureSuccessDesktop.SignatureCenter>
						<StyledSignatureSuccessDesktop.Button  disabled={loading} onClick={exportPdf} className="af-button af-button--secondary">
							<Icon name='download-button' marginRight={8} />
							<StyledSignatureSuccessDesktop.ButtonText>Baixar documento</StyledSignatureSuccessDesktop.ButtonText>
						</StyledSignatureSuccessDesktop.Button>
					</StyledSignatureSuccessDesktop.SignatureCenter>
				</StyledSignatureSuccessDesktop.SignatureContainer>
			</StyledSignatureSuccessDesktop.Signature>
		</StyledSignatureSuccessDesktop>
	);
}

export default SignatureSuccessDesktop;
